import { render, staticRenderFns } from "./IssueCategoriesDelete.vue?vue&type=template&id=4c561048&scoped=true"
import script from "./IssueCategoriesDelete.vue?vue&type=script&lang=js"
export * from "./IssueCategoriesDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c561048",
  null
  
)

export default component.exports